"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getContractorData = exports._deleteVessel = exports._editVessel = exports._createVessel = exports._getMasterVesselByContractor = exports._getMasterVessel = void 0;
const axios_1 = __importDefault(require("axios"));
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const error_response_1 = require("utils/error-response");
const _getMasterVessel = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? (sort.length > 0 ? JSON.stringify(sort) : undefined) : undefined;
    const url = String(process.env.API_ENDPOINT) + '/master-data/vessel';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getMasterVessel = _getMasterVessel;
const _getMasterVesselByContractor = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/vessel/contractor/${arg.id}`;
    const config = {
        params: { vessel_no: arg.vessel_no },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getMasterVesselByContractor = _getMasterVesselByContractor;
const _createVessel = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/vessel';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const { data } = yield axios_1.default.post(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: {
                id: data.data.id,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: '',
            } });
    }
});
exports._createVessel = _createVessel;
const _editVessel = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/vessel/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const { data } = yield axios_1.default.put(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: '',
            } });
    }
});
exports._editVessel = _editVessel;
const _deleteVessel = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/vessel/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const { data } = yield axios_1.default.delete(url, config);
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: true, errorMessage: response.errorMessage, data: {
                id: '',
            } });
    }
});
exports._deleteVessel = _deleteVessel;
const _getContractorData = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor?skip=0&take=1000';
    try {
        const { data } = yield axios_1.default.get(url, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            },
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: data.data,
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            contractor: [],
        };
    }
});
exports._getContractorData = _getContractorData;
